// Fun status lines — data in, personality out.

const WORKING = [
  (s) => (s.task_hint ? `babysitting: ${s.task_hint}` : null),
  () => 'watching the agent type…',
  () => 'agent is cooking',
  () => 'supervising very hard right now',
];
const WAITING = [() => 'agent is waiting for you!', () => 'your turn — agent needs input'];
const DONE = [() => 'agent just finished — go look!', () => 'shipped. taking credit now'];
const ONLINE = [() => 'agent napping nearby', () => 'between runs, agent on standby', () => 'agent idling warm'];
const IDLE = [() => 'agent is asleep', () => 'no agent around'];

function pick(arr, salt) {
  return arr[Math.abs(salt) % arr.length];
}

export function funStatusLine(status) {
  if (!status) return 'between runs';
  const salt = (status.since ?? 0) + (status.task_hint?.length ?? 0);
  const bank =
    status.state === 'working'
      ? WORKING
      : status.state === 'waiting_input'
        ? WAITING
        : status.state === 'done'
          ? DONE
          : status.state === 'online'
            ? ONLINE
            : IDLE;
  for (let i = 0; i < bank.length; i++) {
    const line = pick(bank, salt + i)(status);
    if (line) return line;
  }
  return 'vibing';
}

export function etaText(status) {
  if (status?.state !== 'working' || status.eta_min == null) return '';
  return `~${status.eta_min} min`;
}

// display names: we detect APPS, so say the app's name (data keys stay claude-code)
export function agentLabel(kind) {
  return kind === 'claude-code' ? 'claude' : (kind ?? 'agent');
}
